/*
 * @Author: cmchiu
 * @Date: 2022-03-31 16:46:03
 * @LastEditTime: 2022-09-14 17:43:03
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \campus2022\campus2022-ClientApp\src\main.js
 *
 */
import 'core-js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-TW'
import VueGtag from 'vue-gtag'
import VueGtm from '@gtm-support/vue2-gtm'

Vue.use(ElementUI, { locale, zIndex: 1000 })
Vue.use(
    VueGtag,
    {
        enabled:
            process.env.NODE_ENV === 'production' &&
            process.env.VUE_APP_BASE_API.indexOf('campus.sce.pccu.edu.tw') >= 0,
        config: { id: 'G-BCFBPF7HE7' },
    },
    router
)
Vue.use(VueGtm, {
    enabled:
        process.env.NODE_ENV === 'production' && process.env.VUE_APP_BASE_API.indexOf('campus.sce.pccu.edu.tw') >= 0,
    id: 'GTM-N7RB694',
    vueRouter: router,
    debug: false,
})

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
